import PgaCoachInfoPanel from './pga-coach-info-panel'

export default PgaCoachInfoPanel
